import ForecastingVsBudgetNew from "../components/forecastingvsbudgetnew";

const NewForecastingVsBudgetPage = () => {
    return (<>
        <ForecastingVsBudgetNew />
    </>)
}

export default NewForecastingVsBudgetPage;